import pollyApi from "@/polly/services/polly-client.js"
import { loadDraft } from "@/polly/services/polly-draft.js"

/**
 * The entry of the flow (docs/polly/polly.mermaid): /polly sends somebody signed in with a passkey on to
 * their pollys. Only a draft in the making, or a ?step= ("New polly" in the list, "Start your own" after a
 * ballot), keeps an authenticated user on the form. It is a route guard (`beforeEnter` of createPolly in
 * router.js), not a redirect in mounted(), so the form never flashes up on the way.
 *
 * Only the polly code may know the polly session, which is why this is not a general navigation guard.
 */
export function pollyEntryGuard(to) {
	if (to.name !== "createPolly") return
	const writing = to.query.step !== undefined || !!loadDraft()
	if (pollyApi.hasPasskeySession() && !writing) return { name: "pollys", replace: true }
}
